module.exports = __webpack_public_path__ + "static/media/ab.beb04564.png";